import { Component } from '@angular/core';
import moment from  'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';
import { StockingServiceService } from '../stocking-service.service';
import { Observable } from 'rxjs/internal/Observable';
import { ActivatedRoute, Router } from '@angular/router';
import { take } from 'rxjs';

@Component({
  selector: 'app-menus',
  templateUrl: './menus.component.html',
  styleUrl: './menus.component.css'
})

export class MenusComponent {

  weeks: any[] = []
  selectedWeek = 0
  selectedTab = 0
  fromWeek = 0
  toWeek = 0
  fromYear = 0
  toYear = 0
  currentDate = moment()
  currentWeek = moment().week()
  products$ = new Observable<any>();

  menuHaveUnsavedChanges = false;

  hollydays = {};

  config = {
    weeks: {
      before: 4,
      after: 16,
    }
  }

  lockedWeeks = [

  ]

  constructor(
    private stockingService: StockingServiceService,
    private route: ActivatedRoute,
    private router: Router
  ) {

    // /dashboard/menus/25/31
    // find the deepest child route (where :year/:week will be)
    let r = this.route as ActivatedRoute;
    while (r.firstChild) r = r.firstChild;

    r.paramMap.subscribe(pm => {
      const yearStr = pm.get('year');
      const weekStr = pm.get('week');

      // debug
      console.log('paramMap update:', { yearStr, weekStr });

      const year = yearStr ? parseInt(yearStr, 10) : NaN;
      const week = weekStr ? parseInt(weekStr, 10) : NaN;

      const hasValidParams = !isNaN(year) && !isNaN(week);

      if (!hasValidParams) {
        // redirect to current week — use array args (no string concat) and replaceUrl to avoid history loop
        const targetYear = this.currentDate.format('YY'); // use full year unless you intentionally want 'YY'
        this.router.navigate(['/dashboard', 'menus', targetYear, this.currentWeek], { replaceUrl: true });
      }
      this.selectedTab = this.config.weeks.before;
      this.stockingService.getHollydays$().pipe(take(1)).subscribe(hollydays => this.hollydays = hollydays);
      // this.setupWeeks();
    });

  }

  ngOnInit(): void {
    this.products$ = this.stockingService.getProducts$()
  }

  isLocked(week: any) {
    return this.lockedWeeks.includes(week.week() + "-" + week.year())
  }

  createTabs() {

    this.weeks = []

    const numberOfWeeks = this.config.weeks.before + this.config.weeks.after + 1
    this.selectedWeek = this.currentWeek

    for (let i = 0; i < numberOfWeeks; i++) {

      const thisWeek = moment().week(this.fromWeek).add(i, 'weeks').add(1, "days")

      this.weeks.push({
        tabLabel: thisWeek.format('WW-YY'),
        week: thisWeek,
        isCurrentWeek: thisWeek.isSame(this.currentDate, 'week'),
        isBefore: thisWeek.isBefore(this.currentDate, 'week'),
      })
    }
  }

  getWeekSelectedWeek() {
    console.log("weeks", this.weeks)

    const weekObject = this.weeks.find(week => week.week.week() === this.selectedWeek && week.week.year() === this.currentDate.year());
    console.log("getWeekSelectedWeek", weekObject)
    return weekObject.week; // Not found
  }

  arciveClicked(event: any) {
    console.log("arciveClicked 2235", event)

    // this.setupWeeks(this.config.weeks.before + 4)
  }

  getSelectedTab() {
    return this.selectedTab;
  }

  selectedWeekChanged(event: any) {

    if (event == 0) {
      // console.log("archiveClicked", event)
      // console.log("DOING THIS")
      this.config.weeks.before += 4;

      // this.setupWeeks(this.config.weeks.before + 4)

      this.selectedTab = 1
      this.selectedWeek = 1
    } else {
      this.selectedWeek = event
    }

  }

  menuHaveChanges(event: any) {
    // console.log("menuHaveChanges", event)

    this.menuHaveUnsavedChanges = event;
  }


}
